import { useNavigate } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { 
  Sparkles, 
  FileText, 
  Eye, 
  Leaf,
  Calendar,
} from "lucide-react";

interface PatientQuickActionsProps {
  patientId: string;
}

export function PatientQuickActions({ patientId }: PatientQuickActionsProps) {
  const navigate = useNavigate();

  const actions = [
    {
      label: "Nouveau bilan",
      icon: Sparkles,
      onClick: () => navigate(`/vitality?patientId=${patientId}`),
      variant: "primary" as const,
    },
    {
      label: "Compte rendu",
      icon: FileText,
      onClick: () => navigate(`/session-report?patientId=${patientId}`),
      variant: "secondary" as const,
    },
    {
      label: "Iridologie",
      icon: Eye,
      onClick: () => navigate(`/iridology/new?patientId=${patientId}`),
      variant: "accent" as const,
    },
    {
      label: "Commencer l'analyse",
      icon: Leaf,
      onClick: () => navigate(`/app?patientId=${patientId}`),
      variant: "muted" as const,
    },
  ];

  const variantStyles = {
    primary: "bg-primary hover:bg-primary-hover text-primary-foreground",
    secondary: "bg-secondary hover:bg-secondary-hover text-secondary-foreground",
    accent: "bg-accent hover:bg-accent/90 text-accent-foreground",
    muted: "bg-muted hover:bg-muted/80 text-muted-foreground",
  };

  return (
    <div className="grid grid-cols-2 md:grid-cols-4 gap-3">
      {actions.map((action) => (
        <button
          key={action.label}
          onClick={action.onClick}
          className={`${variantStyles[action.variant]} rounded-xl p-4 flex flex-col items-center gap-2 transition-all hover:scale-[1.02] shadow-soft border border-border/50`}
        >
          <action.icon className="w-6 h-6" />
          <span className="text-sm font-medium text-center">{action.label}</span>
        </button>
      ))}
    </div>
  );
}
